import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useEffect, useState } from "react";
import BookingApi from "../../../API/Apis/BookingApi";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { BookingGetters } from "../../../store/onlineBooking/getters";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { t } from "i18next";
import { AppStandardButton } from "../../UI/AppButtons";
import { useTranslation } from "react-i18next";
import { BOOKING_ACTIONS } from "../../../store/onlineBooking";
import { useDispatch } from "react-redux";

export default function SignIn({ openPayment, callFrom }) {
  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }

  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);
  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";

  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: 800,
        },
      },
      targetOrigin
    );
  }

  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      targetOrigin
    );
  };
  const showNewIFrame = (iframeFor) => {
    window.parent.postMessage(
      {
        event_id: iframeFor,
      },
      targetOrigin
    );
  };
  useEffect(() => {
    requestParentResize();
  }, []);
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email is required").email("Email is invalid"),
    password: Yup.string().required("Password is required"),
  });
  const bookingInformation = BookingGetters.getBookingDetails();
  const dispatch = useDispatch();
  const isDesktopScreen = window.innerWidth >= 1310;
  const isSmallScreen = window.innerWidth <= 768;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  // const handleSignupNavigation = (e) => {
  //   e.preventDefault();
  //   if (callFrom == "booking") {
  //     navigate("/signup?callFrom=booking", {
  //       state: { from: window.location.href },
  //     });
  //   } else {
  //     navigate("/signup", { state: { from: window.location.href } });
  //   }
  // };

  const handleForgotPasswordNavigation = (e) => {
    e.preventDefault();
    navigate("/forgotpassword");
  };
  const paymentDetailsSelected =
    BookingGetters.getSelectedVehicleDetails()?.paymentDetails;
  const extrasSelected = paymentDetailsSelected?.addedExtraOptions;
  const [isDriverOptionalSelected, setIsDriverSelected] = useState(false);
  useEffect(() => {
    if (
      typeof extrasSelected === "object" &&
      extrasSelected !== null &&
      "DRIVER" in extrasSelected
    ) {
      setIsDriverSelected(true);
    } else {
      setIsDriverSelected(false);
    }
  }, [extrasSelected]);
  const reduxStoredDealer =
    bookingInformation?.pickUpLocationDetails?.showLoggedInDealerLoc;
  const dealerId = bookingInformation?.pickUpLocationDetails?.dealerId || "";
  // Function to handle storing user data in localStorage
  const storeUserData = (userData) => {
    localStorage.setItem("userID", userData?.id);
    localStorage.setItem(
      "onlineuserFName",
      userData?.name?.split(" ")[0] || ""
    );
    localStorage.setItem(
      "onlineuserLName",
      userData?.name?.split(" ")[1] || ""
    );
    localStorage.setItem("onlineuserEmailId", userData?.email);
    localStorage.setItem("idSupplier", userData?.dealerId);
    localStorage.setItem(
      "redirectToFirstPage",
      userData?.showLoggedInDealerLoc
    );
    localStorage.setItem("isUserLoggedin", "true");
    localStorage.setItem("isPhysicalPerson", userData?.isPhysicalPerson);
    localStorage.setItem("mobileNumber", userData?.mobileNumber);
    localStorage.setItem(
      "attachedCustomer",
      userData?.attachedCustomer !== "no customer found"
        ? userData.attachedCustomer
        : "undefined"
    );
    // Remove unnecessary localStorage items
    ["attachedDriver", "attachedDriver2", "attachedDriver3"].forEach((item) =>
      localStorage.removeItem(item)
    );
  };

  // Function to handle navigation based on conditions
  const handleNavigation = (
    userData,
    reduxStoredDealer,
    navigate,
    openPayment,
    isDriverOptionalSelected
  ) => {
    if (String(userData.showLoggedInDealerLoc) !== String(reduxStoredDealer)) {
      dispatch(BOOKING_ACTIONS.resetBookingInformation());
      navigate("/", { state: { from: window.location.href } });
      showNewIFrame("showIFrameForBooking");
      return;
    }
    if (openPayment) {
      if (userData.attachedCustomer === "no customer found") {
        navigate(`/anagraphData?isCallFromBooking=true`);
      } else if (localStorage.getItem("isPhysicalPerson") === "false") {
        navigate(
          `/driverForm?isCompanyUserType=true&isDriverFromAnagraph=true&isCallFromBooking=true&isDriver=true&showRecep=true`
        );
      } else if (isDriverOptionalSelected) {
        navigate(`/driverForm?&isCallFromBooking=true&isDriver=true`);
      } else {
        navigate("/paymentData?fromSignIn=true");
      }
    } else {
      navigate("/", { state: { from: window.location.href } });
      showNewIFrame("showIFrameForBooking");
    }
  };

  const onSubmit = (data) => {
    if (data.remember) {
      localStorage.setItem("email", data.email);
      localStorage.setItem("password", data.password);
    } else {
      localStorage.removeItem("email");
      localStorage.removeItem("password");
    }

    const isBlacklisted = (userData) =>
      userData?.isBlocklistCustomer?.toString() === "true";

    const isSuccessfulLogin = (userData) =>
      userData.status === "success" &&
      (userData.isBlocklistCustomer?.toString() === "false" ||
        userData.isBlocklistCustomer == null);

    // API Call and handling response
    BookingApi.loginUser(data, dealerId).then((response) => {
      const userData = response.data;

      if (isSuccessfulLogin(userData)) {
        storeUserData(userData);
        handleNavigation(
          userData,
          reduxStoredDealer,
          navigate,
          openPayment,
          isDriverOptionalSelected
        );
        return;
      } else if (isBlacklisted(userData)) {
        setModalMessage(
          "Online user is blacklisted. We cannot log in with these credentials."
        );
        setOpenModal(true);
      } else if (userData.status === "error") {
        setModalMessage(userData.errorMessage);
        setOpenModal(true);
      }
    });
  };

  const { t: translate } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const requestOnClose = () => {
    setOpenModal(false);
    setModalMessage("");
  };

  useEffect(() => {
    scrollToTop();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="min-h-screen w-full flex justify-center items-center bg-white">
        <div className="w-full" style={{ maxWidth: "1540px" }}>
          <div
            className="grid grid-cols-1 md:grid-cols-2 bg-cover min-h-screen"
            style={isDesktopScreen ? { margin: "0px" } : { margin: "0px" }}
          >
            <div
              style={
                isDesktopScreen
                  ? { width: "95%", marginTop: "15%" }
                  : { margin: "60px 27px" }
              }
            >
              <img
                src="/assets/images/SiteLogo.jpg"
                alt={"logo"}
                style={
                  isDesktopScreen
                    ? {
                        height: "118px",
                        width: "210.03px",
                        marginLeft: "26px",
                      }
                    : { marginLeft: "-20%", width: "50%" }
                }
              />
              <div
                style={{
                  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  color: "#1E1E1E",
                  fontSize: "36px",
                  marginTop: isDesktopScreen ? "60px" : "0px",
                  marginLeft: isDesktopScreen ? "112px" : "",
                }}
              >
                {translate("Login")}
              </div>
              <div
                style={{
                  fontFamily: "MBCorpoSText-Regular-Web-new",
                  color: "#1E1E1E",
                  fontSize: "24px",
                  marginTop: isDesktopScreen ? "14px" : "0px",
                  marginLeft: isDesktopScreen ? "112px" : "",
                  width: isDesktopScreen ? "358px" : "",
                  height: "110px",
                }}
              >
                {translate(
                  "Access your account to make and manage bookings and access rental histories"
                )}
              </div>
            </div>
            <div
              className="flex flex-col items-center w-full"
              style={{
                backgroundColor: "#000000",
                width: isDesktopScreen ? "105%" : "",
                height: isDesktopScreen ? "100%" : "100%",
              }}
            >
              <div className="w-[100%]">
                <Container
                  component="main"
                  style={{
                    margin: "7px",
                    marginLeft: isDesktopScreen ? "20%" : "7px",
                  }}
                >
                  <Grid>
                    <Box
                      component="form"
                      onSubmit={handleSubmit(onSubmit)}
                      noValidate
                      sx={{
                        "& .MuiTextField-root": {
                          mt: 2,
                          width: isDesktopScreen ? "40ch" : "",
                          backgroundColor: "white",
                        },
                      }}
                    >
                      <h1
                        className=""
                        style={{
                          color: "#FFFFFF",
                          fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                          marginTop: isDesktopScreen ? "160px" : "60px",
                          fontSize: "36px",
                        }}
                      >
                        {translate("Login")}
                      </h1>
                      <div
                        className="text-white mt-[5%]"
                        style={{ fontFamily: "MBCorpoSText-CondLight-Web" }}
                      >
                        Username/Email
                      </div>
                      <Grid item xs={12}>
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          id="email"
                          label={t("Username/Email")}
                          size="medium"
                          autoComplete="off"
                          style={{
                            width: isDesktopScreen ? "418px" : "94%",
                            marginLeft: isSmallScreen ? "5px" : "",
                            backgroundColor: "#D9D9D9",
                            color: "black",
                            borderRadius: "8px",
                          }}
                          autoFocus
                          {...register("email")}
                          error={!!errors.email}
                          InputProps={{
                            className: "MBCorpoSText-Regular-Web-new",
                          }}
                          InputLabelProps={{
                            className: "MBCorpoAScreen1Cond-Regular-Web",
                            sx: {
                              "&.MuiInputLabel-root": {
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                              },
                              "&.MuiInputLabel-shrink": {
                                display: "none",
                              },
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "transparent",
                              },
                              "&:hover fieldset": {
                                borderColor: "transparent",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "transparent",
                              },
                            },
                            "& .MuiInputBase-input": {
                              fontFamily: "MBCorpoSText-Regular-Web-new",
                              height: "20px",
                            },
                          }}
                        />
                        <Typography
                          variant="inherit"
                          color="#FFFFFF"
                          style={{
                            color: "red",
                            fontFamily: "MBCorpoSText-Regular-Web-new",
                          }}
                        >
                          {errors.email?.message}
                        </Typography>
                      </Grid>
                      <div
                        className="text-white"
                        style={{ fontFamily: "MBCorpoSText-CondLight-Web" }}
                      >
                        Password
                      </div>
                      <Grid item xs={12}>
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          style={{
                            width: isDesktopScreen ? "418px" : "94%",
                            marginLeft: isSmallScreen ? "5px" : "",
                            backgroundColor: "#D9D9D9",
                            color: "black",
                            borderRadius: "8px",
                          }}
                          label={t("Password")}
                          type="password"
                          id="password"
                          size="medium"
                          autoComplete="off"
                          {...register("password")}
                          error={!!errors.password}
                          InputProps={{
                            className: "MBCorpoSText-Regular-Web-new",
                          }}
                          InputLabelProps={{
                            className: "MBCorpoAScreen1Cond-Regular-Web",
                            sx: {
                              "&.MuiInputLabel-root": {
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                              },
                              "&.MuiInputLabel-shrink": {
                                display: "none",
                              },
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "transparent",
                              },
                              "&:hover fieldset": {
                                borderColor: "transparent",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "transparent",
                              },
                            },
                            "& .MuiInputBase-input": {
                              height: "20px",
                            },
                          }}
                        />
                        <Typography
                          variant="inherit"
                          color="#FFFFFF"
                          style={{
                            color: "red",
                            fontFamily: "MBCorpoSText-Regular-Web-new",
                          }}
                        >
                          {errors.password?.message}
                        </Typography>
                      </Grid>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{
                          mt: 3,
                          mb: 2,
                          color: "#FFFFFF",
                          fontWeight: "bold",
                          bgcolor: `#0078D6 !important`,
                          fontFamily: "MBCorpoSText-Regular-Web-new",
                          height: "51px",
                          width: isDesktopScreen ? "418px" : "94%",
                          marginLeft: isDesktopScreen ? "" : "5px",
                        }}
                      >
                        {translate("Login")}
                      </Button>
                      <Grid
                        container
                        style={{
                          width: isDesktopScreen ? "418px" : "94%",
                          marginLeft: isDesktopScreen ? "" : "5px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "5px",
                        }}
                      >
                        <Grid item>
                          <Link
                            onClick={handleForgotPasswordNavigation}
                            variant="body2"
                            component="button"
                            underline="none"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span
                              className="text-[#FFFFFF]"
                              style={{
                                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                                fontSize: "15px",
                              }}
                            >
                              {translate("Forgot Password")}?
                            </span>
                          </Link>
                        </Grid>
                        {/* <Grid item>
                          <Link
                            onClick={handleSignupNavigation}
                            variant="body2"
                            component="button"
                            underline="none"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span
                              className="text-[#FFFFFF]"
                              style={{
                                fontFamily: "MBCorpoAScreen1Cond-Regular",
                                fontSize: "15px",
                              }}
                            >
                              {t("Are you not registered yet?")}{" "}
                              <span style={{ color: "#49bdfb" }}>
                                {t("Signup")}
                              </span>
                            </span>
                          </Link>
                        </Grid> */}
                      </Grid>
                    </Box>
                  </Grid>
                </Container>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          open={openModal}
          onClose={requestOnClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              borderRadius: "10px",
              minWidth: "370px",
              position: "absolute",
              top: isDesktopScreen ? "50%" : "50%",
              left: isDesktopScreen ? "50%" : "40%",
              transform: "translate(-50%, -50%)",
            },
          }}
        >
          <DialogTitle
            style={{
              padding: "1rem",
              fontFamily: "MBCorpoSText-Regular-Web-new",
            }}
          >
            {modalMessage}
          </DialogTitle>
          <DialogActions
            sx={{
              justifyContent: "center",
            }}
          >
            <AppStandardButton variant="outlined" onClick={requestOnClose}>
              <p className="text-black normal-case">{t("Close")}</p>
            </AppStandardButton>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}
